module.exports = __webpack_public_path__ + "img/updateAppoint_b.57ef5fe2.png";